<template>
  <fieldset class="set-pair-combi_container">
    <button class="set-pair-combi_btn" type="button" @click="() => resolve(false)">
      <img src="../../assets/img/parts/drape_selected.svg"
        class="combi_illust"
        width="46"
        height="52"
        alt="上:ドレープ/下:レース"
      />
      <dl class="combi_caption">
        <dt class="combi_label">上</dt><dd class="combi_name">ドレープ</dd>
        <dt class="combi_label">下</dt><dd class="combi_name">レース</dd>
      </dl>
    </button>
    <button class="set-pair-combi_btn" type="button" @click="() => resolve(true)">
      <img src="../../assets/img/parts/lace_selected.svg"
        class="combi_illust"
        width="46"
        height="52"
        alt="上:レース/下:ドレープ"
      />
      <dl class="combi_caption">
        <dt class="combi_label">上</dt><dd class="combi_name">レース</dd>
        <dt class="combi_label">下</dt><dd class="combi_name">ドレープ</dd>
      </dl>
    </button>
  </fieldset>
</template>

<script>
export default {
  name: 'SetPairCombi',
  props: {
    toSettle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    resolve () {
      return (val) => this.toSettle?.resolve(val)
    },
  }
}
</script>

<style lang="scss" scoped>
.set-pair-combi_container {
  box-sizing: border-box;
  container-type: inline-size;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin: 0;
  margin-inline: 5%;
  padding: 5%;
  width: 100%;
  height: 100%;
  border: none;
  .set-pair-combi_btn {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 5% 4.5%;
    width: 90%;
    aspect-ratio: auto 65 / 96;
    // height: 30%;
    text-align: left;
    border: 2px solid transparent;
    border-radius: 16px;
    &:hover {
      border: 2px solid #000;
    }
    &:active {
      border: 2px solid #000;
      transform: translate3d((2px, 2px, 0));
    }
    .combi_illust {
      width: calc(50 / 65 * 100%);
      height: auto;
    }
    .combi_caption {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-auto-rows: auto;
      margin: 0;
      font-size: clamp(10px, 1.5vw, 15px);
      font-size: clamp(10px, 13cqw, 16px);
      .combi_label {
        &::after {
          display: inline-block;
          content: ':';
        }
      }
      .combi_name {
        flex: 1 0 auto;
        margin: 0;
      }
    }
  }
}
</style>
